import {
  REQUEST_REGIONS,
  RECEIVE_REGIONS,
  RECEIVE_REGION,
} from "../actions/dst-regions";

const reducer = (
  state = {
    items: [],
    loading: false,
    item: {},
  },
  action,
) => {
  switch (action.type) {
    case REQUEST_REGIONS:
      return { ...state, loading: true };
    case RECEIVE_REGIONS:
      return { ...state, items: action.json.data, loading: false };
    case RECEIVE_REGION:
      return {
        ...state,
        item: action.json,
        loading: false,
      };
    default:
      return state;
  }
};

export default reducer;
